import styled, { css, keyframes } from "styled-components";
import { Modal as AntdModal } from "antd";

export const LayoutContainer = styled.div``;

export const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const appear = keyframes`
  /* from {
    opacity: 0;
  }
  to {
    opacity: 1;
  } */

    0% {
      opacity: 0;
      transform: translateX(-50px);
  }
  20% {
    transform: translateX(50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Layouts = styled.div`
  display: grid;
  place-content: center;
  grid-template-columns: repeat(auto-fill, minmax(330px, 330px));
  gap: 24px;
`;

export const Modal = styled(AntdModal)`
  .ant-modal-content {
    border-radius: 13.79px;
  }
`;

export const ModalHeader = styled.header`
  --gray: #3a3a3c;
  --OpenSans: "Open Sans", sans-serif;
  --gray2: #444444;

  width: fit-content;
  margin-left: auto;
  margin-right: auto;

  & > div {
    display: flex;
    gap: 2.19px;
    align-items: center;
  }

  p {
    color: var(--gray);
    font-weight: 600;
    font-family: var(--OpenSans);
    font-size: 18px;
    line-height: 13.79px;
    margin-bottom: 0;
  }

  & > span {
    color: var(--gray2);
    font-weight: 400;
    font-family: var(--OpenSans);
    font-size: 14px;
    line-height: 13.79px;
    margin-bottom: 0;
  }
`;

export const ModalDivider = styled.div`
  margin: 16px 0;
  width: 100%;
  background-color: #dde5e9;
  height: 0.57px;
`;

export const Wrapper = styled.div`
  cursor: pointer;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0);
  transition: all 0.3s ease-in-out;

  &:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.45);
  }

  ${({ currentColor, index }) =>
    !currentColor &&
    css`
      & > div {
        opacity: 0;
        animation: ${appear} 1s ${index * 0.2}s forwards;
      }
    `}
`;

export const TabContainer = styled.div`
  height: 365px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;
